import { ProviderSetStagedMap } from "@app/operations/market-nightly-refresh/interfaces";
import { QESAlert } from "@app/shared/qes-standards/Alert";
import { QESButton } from "@app/shared/qes-standards/Button";
import { FC } from "react";

interface PendingChangesBannerProps {
  changes: ProviderSetStagedMap;
  toExclude: number;
  toInclude: number;
  onApply: () => void;
  onCancel: () => void;
  isApplying: boolean;
}

export const PendingChangesBanner: FC<PendingChangesBannerProps> = ({ changes, toExclude, toInclude, onApply, onCancel, isApplying }) => {
  if (changes.size === 0) return null;
  return (
    <div>
      <QESAlert classNames="market-nightly-refresh__pending-changes" type="info" persist={true}>
        <span>
          Pending changes: {toExclude > 0 && <>{<strong>{toExclude}</strong>} to ignore</>}
          {toExclude > 0 && toInclude > 0 && ", "}
          {toInclude > 0 && <>{<strong>{toInclude}</strong>} to remove ignore</>}.
          {" "}These won&apos;t take effect until applied.
        </span>
        <div className="market-nightly-refresh__pending-changes-buttons">
          <QESButton qesType="secondary" onClick={onCancel} disabled={isApplying} qesTestId="mnr-pending-banner__cancel">Cancel</QESButton>
          <QESButton onClick={onApply} disabled={isApplying} qesTestId="mnr-pending-banner__apply">Apply changes</QESButton>
        </div>
      </QESAlert>
    </div>
  )
}
